import {EContentType} from 'src/constants';

import {ETemplateButtonOtpType} from '../MessageMatchers/WhatsAppForm/definitions';
import {EMessageMatcherButtonTypes} from '../MessageMatchers/definitions';
import {EMenuButtonAction} from './Item/types';
import {ECommonMenuType} from './Layout/constants';
import {EFlowStatus, EFlowStepType, EUIActionType, EUIConditionType, EUIStepError} from './types';

export default {
  createTrigger: 'chain',
  empty: {
    title: 'This is empty for now',
  },
  status: {
    [EFlowStatus.DRAFT]: 'Draft',
    [EFlowStatus.ACTIVE]: 'Active',
    [EFlowStatus.INACTIVE]: 'Inactive',
    [EFlowStatus.SCHEDULED]: 'Scheduled',
    [EFlowStatus.FINISHED]: 'Finished',
  },
  type: {
    [EFlowStepType.TRIGGER]: 'Start block',
    [EFlowStepType.CONDITION]: 'Condition',
    [EFlowStepType.ACTION]: 'Action',
  },
  changeCondition: 'Change condition',
  blockSettings: 'Block settings',
  transitions: 'Transitions: {{count}}',
  description: {
    [EFlowStepType.TRIGGER]: 'A starting condition for your script',
    [EFlowStepType.CONDITION]: 'Select condition',
    [EFlowStepType.ACTION]: 'Select action',
    [EUIActionType.CC_DIALOG_SWITCH_ACTION]:
      'The conversation with the recipient will be transferred to edna Сhat Сenter',
    [EUIActionType.JIVO_DIALOG_SWITCH_ACTION]:
      'The conversation with the recipient will be transferred to Jivo',
    [EUIActionType.CALLBACK_DIALOG_SWITCH_ACTION]:
      'The conversation with the recipient will be converted into a callback for incoming messages',
    [EUIActionType.PAUSE_ACTION]:
      'The recipient will not receive any messages from the script during this pause',
    [EUIActionType.ADD_SUBSCRIBER_TAG_ACTION]: 'Select tags to assign to all recipients',
    [EUIActionType.DELETE_SUBSCRIBER_TAG_ACTION]: 'Select tags to remove from recipients data',
    [EUIConditionType.TAG_PRESENCE_CONDITION]: 'Select recipients based on tags',
    [EUIConditionType.BUTTON_PRESSED]: 'Select recipients based on buttons that they click',
    [EUIConditionType.MESSAGE_RECEIVED]: 'Select recipients who responded with a message',
    [EUIConditionType.EXTERNAL_TRIGGER]: 'Recipients for whom an external trigger will be started',
  },
  title: {
    [EUIActionType.PAUSE_ACTION]: 'Enter waiting time',
  },
  trigger: {
    [EUIConditionType.MESSAGE_RECEIVED]: {
      title: 'Incoming message received',
      subtitle: 'Recipient sent a message',
    },
    [EUIConditionType.ANSWER_TIMEOUT_CONDITION]: {
      title: 'to meet each of these conditions',
    },
    [EUIConditionType.EXTERNAL_TRIGGER]: {
      title: 'External trigger',
      subtitle: 'Recipients for whom an external trigger will be started',
    },
    [EUIConditionType.BUTTON_PRESSED]: {
      title: 'Button click',
      buttonLabel: 'Button name',
      buttonId: 'Button code',
      emptySubtitle: 'Button values not configured',
    },
    [EUIConditionType.TAG_ASSIGN_TIMEOUT_CONDITION]: {
      title: 'Time since tag was assigned',
      delay: 'Time since tag was assigned to a recipient',
      tags: 'Tag assigned to a recipient',
    },
    [EUIConditionType.TAG_PRESENCE_CONDITION]: {
      title: 'Recipients with tags',
      include: 'Include',
      exclude: 'Exclude',
    },
    [EUIActionType.ADD_SUBSCRIBER_TAG_ACTION]: 'Assign tags',
    [EUIActionType.DELETE_SUBSCRIBER_TAG_ACTION]: 'Remove tags',
    [EUIActionType.CC_DIALOG_SWITCH_ACTION]: 'Transfer conversation to edna Сhat Сenter',
    [EUIActionType.JIVO_DIALOG_SWITCH_ACTION]: 'Transfer conversation to Jivo',
    [EUIActionType.CALLBACK_DIALOG_SWITCH_ACTION]: 'Convert conversation into callback',
    [EUIActionType.SEND_MESSAGE_ACTION]: 'Send a template WhatsApp message',
    [EUIActionType.CREATE_MESSAGE_ACTION]: 'Send a WhatsApp message',
    [EUIActionType.PAUSE_ACTION]: 'Wait for response',
  },
  triggerDescription: {
    [EUIActionType.CC_DIALOG_SWITCH_ACTION]: 'The conversation will continue in edna Сhat Сenter',
    [EUIActionType.JIVO_DIALOG_SWITCH_ACTION]: 'The conversation will continue in Jivo',
    [EUIActionType.CALLBACK_DIALOG_SWITCH_ACTION]: 'The conversation will continue via a callback',
  },
  createMessageAction: {
    messageText: 'Message text',
    addButtons: 'Add buttons',
    addButton: 'Add button',
    buttonsLimit: 'Up to 3 quick reply buttons',
    buttonTitle: 'Chat button',
    buttonText: `Button text (maximum 20 characters)`,
    buttonCode: `Button code, payload (maximum 128 characters)`,
  },
  pauseAction: {
    createMessageHint:
      'If the next block is the "Send a WhatsApp message" action, remember that the waiting time cannot exceed 23 hours and 59 minutes, as a message without a template can only be sent within one day of the user\'s last reply',
  },
  sendMessageAction: {
    template: 'Template',
    ignoreSchedule: 'Ignore broadcast schedule',
    messageMatcherId: 'Select a message template available for this signature',
    hasImage:
      'This template has an image in the header. Upload the image from your computer or enter a link to the image',

    hasAttachment: {
      [EContentType.IMAGE]:
        'This template has an image in the header. Upload the image from your computer or enter a link to the image.',
      [EContentType.VIDEO]:
        'This template has a video in the header. Upload the video from your computer or enter a link to the video.',
      [EContentType.DOCUMENT]:
        'This template has a document in the header. Upload the document from your computer or enter a link to the document.',
    },
    upload: 'Upload',
    addLink: 'Insert link to file',
    imageHint: 'Image (PNG or JPG up to 5 MB)',
    viewTemplate: 'Preview the template',
    linkHint: {
      [EContentType.IMAGE]: 'Image link (no more than 200 characters)',
      [EContentType.VIDEO]: 'Video link (no more than 200 characters)',
      [EContentType.DOCUMENT]: 'Document link (no more than 200 characters)',
    },
    button: 'Button',
    buttonName: 'Button name',
    buttonText: 'Button text',
    buttonCode: 'Button code',
    buttonType: 'Button type',
    buttonTypeLabel: {
      [EMessageMatcherButtonTypes.PHONE]: 'Call button',
      [EMessageMatcherButtonTypes.URL]: 'Link button',
      [EMessageMatcherButtonTypes.CHAT]: 'Chat button',
      [ETemplateButtonOtpType.COPY]: 'Copy code',
      [ETemplateButtonOtpType.AUTO]: 'One-tap autofill',
    },
    staticUrl: 'Static part of the URL',
    dynamicUrl: 'Dynamic part of the URL',
    phoneNumber: 'Phone number',
    viewMessage: 'View message',
    attachFile: 'Upload file',
    back: 'Back',
    done: 'Done',
    dynamicUrlRequired: 'Dynamic link component cannot be empty',
  },
  forms: {
    [EUIConditionType.BUTTON_PRESSED]: {
      button: 'Button',
      buttonLabel: 'Button name (must match the template)',
      buttonId: 'Button code, payload (must match the template)',
      addButton: 'Add button',
    },
    [EUIConditionType.TAG_ASSIGN_TIMEOUT_CONDITION]: {
      delay: 'Time since tag was assignment to a recipient',
      tags: 'Tag assigned to a recipient',
    },
    [EUIConditionType.TAG_PRESENCE_CONDITION]: {
      tagsTree: 'Tag tree',
    },
    [EUIConditionType.ANSWER_TIMEOUT_CONDITION]: {
      title: 'Configure condition block',
      hint_1: [
        'At the same time as the "Click button" condition, the "Incoming message received" condition is activated.',
        "This way you won't lose users who don't click the button in response to a message, but write to you themselves.",
      ].join('<br/>'),
      hint_2:
        'For users who send an incoming message, you can configure a separate script thread from this block.',
      hint_3: 'The same response waiting time applies to meet each of these conditions',
      answerTimeout: 'Response waiting time:',
      save: 'Save setting',
    },
  },
  tag: 'Tag',
  systemWaiting: 'Waiting for',
  condition: {
    yes: 'Yes',
    no: 'No',
    notCompleted: 'Not completed',
  },
  contextMenu: {
    add: 'Add',
    deleteEdge: 'Delete',
    deleteBlock: 'Delete block?',
    duplicateBlock: 'Duplicate block',
    deleteTrigger: 'Delete trigger?',
    duplicateTrigger: 'Duplicate trigger',
  },
  addButton: {
    [EFlowStepType.TRIGGER]: 'Select a condition',
    [EFlowStepType.CONDITION]: 'Select a condition',
    [EFlowStepType.ACTION]: 'Select an action',
  },
  menu: {
    [EFlowStepType.ACTION]: 'Action',
    [EFlowStepType.CONDITION]: 'Condition',

    [ECommonMenuType.SETTINGS]: 'Settings',
    [ECommonMenuType.HELP]: 'Help',
    [ECommonMenuType.NOTIFICATIONS]: 'Event log',
    [ECommonMenuType.SIGN_OUT]: 'Signout',
  },
  actionButton: {
    [EMenuButtonAction.START]: 'Start script',
    [EMenuButtonAction.STOP]: 'Stop script',
    [EMenuButtonAction.SETTINGS]: 'View settings',
    [EMenuButtonAction.VIEW]: 'View script',
    [EMenuButtonAction.EDIT]: 'Edit script',
    [EMenuButtonAction.COPY]: 'Copy script',
    [EMenuButtonAction.CANCEL]: 'Cancel script',
    [EMenuButtonAction.DELETE]: 'Delete script',
  },
  filters: {
    searchPlaceholder: 'Quick search by name',
    flows: 'Scripts',
  },
  th: {
    activatedAt: 'Start date',
    name: 'Script name',
    status: 'Status',
    started: 'Started',
    startedHint: 'How many recipients were processed by the starting block of the script',
    inProgress: 'Running',
    inProgressHint: 'How many recipients are going through the script',
    finished: 'Completed',
    finishedHint: 'How many recipients completed the script successfully',
  },
  successModal: {
    [EMenuButtonAction.START]: {
      title: 'Your script started successfully!',
      message: 'Script step transition statistics will be displayed in the list of scripts',
      confirmButton: 'Ок',
    },
  },
  modal: {
    [EMenuButtonAction.STOP]: {
      title: 'Stop the script?',
      message: 'There are currently no active participants in this script.',
      titleActive: 'Stop the script with participants?',
      messageActive:
        'There are <0>{{count}} participants</0> involved in the script. If you stop now, the participants will not be able to complete it.',
      confirmButton: 'Stop',
    },
    [EMenuButtonAction.START]: {
      title: 'Start script?',
      message: 'Once you run the script, you cannot edit it',
      confirmButton: 'Start',
    },
    [EMenuButtonAction.CANCEL]: {
      title: 'Cancel the script?',
      message:
        "You can't restart a cancelled script. To use this scenario again, you must duplicate and save it with a new name and schedule.",
      confirmButton: 'Cancel start',
    },
    [EMenuButtonAction.DELETE]: {
      title: 'Delete the script?',
      message: 'This will also delete all settings in the script. Are you sure?',
      confirmButton: 'Delete',
    },
    [EMenuButtonAction.COPY]: {
      title: 'Copy the script?',
      message:
        'All blocks and links in the script will be copied. The copy requires a new name and schedule.',
      confirmButton: 'Copy',
    },
    [EFlowStepType.TRIGGER]: {
      title: 'Choose the trigger to start your chain from',
    },
    [EFlowStepType.CONDITION]: {
      title: 'Select a condition',
    },
    [EFlowStepType.ACTION]: {
      title: 'Select an action',
    },
    saveError: {
      title: 'Saving is not possible. The script contains errors',
      message:
        "We can't save the script if there are errors. Fix the errors in the red-highlighted blocks and save the script again",
      confirmButton: 'Fix errors',
      cancelButton: "Don't save",
    },
    saveCyclesError: {
      title: 'The script contains a closed loop',
      message:
        'Some script blocks loop between each other. This can lead to clients going through the same steps repeatedly',
      confirmButton: 'Save as is',
      checkButton: 'Go back and check',
    },
    activateCyclesError: {
      title: 'Run the script with a loop?',
      message:
        'Some script blocks loop between each other. This can lead to clients going through the same steps repeatedly',
      confirmButton: 'Run as is',
      checkButton: 'Go back and check',
    },
    confirmLeave: {
      title: 'Save script?',
      message:
        'If you exit without saving the script, all the data will be lost. You will need to recreate or edit the script',
      confirmButton: 'Exit',
    },
  },
  notification: {
    activateSuccess: 'Your script started successfully!',
    deactivateSuccess: 'Script stopped',
    saveSuccess: 'Script successfully saved',
    saveError: "The script couldn't be saved due to an unknown error",
  },
  errors: {
    tagsRequired: 'You must select at least one tag',
    [EUIStepError.MISSING_DATA]: "Block settings are missing. The script can't be started.",
    [EUIStepError.MISSING_TRIGGER_DATA]:
      'You must select at least one condition for your start block',
    [EUIStepError.NOT_LAST_FLOW_STEP]: "A condition can't be the last block in a script",
    [EUIStepError.MESSAGE_TIMEOUT_TOO_LONG]:
      "This action is not possible. You can only send a message without a template within 24 hours of the user's reply. Change the action or waiting time in the previous block",
    [EUIStepError.EMPTY_BUTTON_CONDITION]: 'Select button values',
  },
  report: {
    title: 'Script report',
    description: 'Generate and upload a report on how recipients interact with the script',
    generate: 'Generate report',
    flowName: 'Script name',
    download: 'Script report',
    pendingNotification: 'Generating a report on the {{name}} script. <0>View the result</0>',
  },
};
